
let React = require("react");

let MasterPage = require("./generic/MasterPage.jsx");
let AssetDetail = require("./generic/AssetDetail.jsx");
let PackagePreview = require("../controls/preview/PackagePreview.jsx"); 
let PackageMetaData = require("../controls/metaData/PackageMetaData.jsx");
let ExportLBRButton = require("../controls/buttons/infoPageButtons/ExportLBRButton.jsx");
let EditAssetButton = require("../controls/buttons/infoPageButtons/EditAssetButton.jsx");
let View3DModelButton = require("../controls/buttons/infoPageButtons/View3DModelButton.jsx");
let DeleteInfoButton = require("../controls/buttons/infoPageButtons/DeleteInfoButton.jsx");
let PublicPrivateButton = require("../controls/buttons/infoPageButtons/PublicPrivateButton.jsx"); 


class PackageDetail extends React.Component {

    constructor() {
        super();
        this.WrapperView3DModelButton = props => <View3DModelButton {...props} {...this.props}/>
    }

    render() {
        console.log(this.props)

        return (
            <MasterPage
                {...this.props}
                renderPage={addedProps => 
                    <AssetDetail
                        {...addedProps}
                        {...this.props}
                        className="packages"
                        urlName="packages"
                        displayName="Package"
                        Preview={PackagePreview}
                        buttons={[
                            ExportLBRButton,
                            PublicPrivateButton,
                            EditAssetButton,
                            this.WrapperView3DModelButton,
                            DeleteInfoButton
                        ]}
                        MetaData={PackageMetaData}
                    /> 
                }
            />
        );
    }
}

module.exports = PackageDetail;
